export default Object.freeze({
  Undergrad: 'HE-UNDGRD',
  Postgrad: 'HE-PGRAD',
  International: 'HE-INTERN',
  Research: 'RESEARCH',
  HigherEdOffshore: 'HE-OFFSHRE',
  TAFEOffshore: 'VE-OFFSHRE',
})
